import Box from 'app/components/base/Box'
import Stack, { StackProps } from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import PoweredLogo from './components/PoweredLogo'
import { getCards } from './helpers/paymentCards.helpers'

interface PaymentCardsProps {
  paymentMethod: CheckoutPayment
  title: string
  showPoweredLogo?: boolean
  sx?: StackProps['sx']
}

const PaymentCards: RFC<PaymentCardsProps> = ({
  paymentMethod,
  title,
  showPoweredLogo,
  sx
}) => {
  const cards = getCards(paymentMethod)

  return (
    <Stack
      spacing={1}
      sx={{
        pb: 3,
        mb: 1,
        ...(showPoweredLogo && {
          alignItems: 'center'
        }),
        ...sx
      }}
    >
      <Text variant="body2" color="text.third">
        {title}
      </Text>

      <Stack
        direction="row"
        sx={{ flexWrap: 'wrap', ...(IS_NATIVE_APP && { rowGap: 1 }) }}
      >
        {cards.map((item, index) => (
          <Box key={index} sx={{ mr: 1 }}>
            {item.icon}
          </Box>
        ))}
      </Stack>

      {showPoweredLogo && <PoweredLogo paymentMethod={paymentMethod} />}
    </Stack>
  )
}

export default PaymentCards
